import React, { createContext, useContext } from 'react';
import type { useFeedbackAttachments } from './useFeedbackAttachments';

export type FeedbackAttachmentContextValue = ReturnType<typeof useFeedbackAttachments>;

const FeedbackAttachmentContext = createContext<FeedbackAttachmentContextValue | null>(null);

export function useFeedbackAttachmentActions() {
    const context = useContext(FeedbackAttachmentContext);
    if (!context) {
        throw new Error('useFeedbackAttachmentActions must be used within FeedbackAttachmentProvider');
    }
    return context;
}

export default FeedbackAttachmentContext;
